import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';

class PartSlider extends Component {
	render() {
		let nrSteps = Object.keys(this.props.steps).length;
		let min = Object.keys(this.props.steps)[0];
		let max = Object.keys(this.props.steps)[nrSteps - 1];
		let sliderSteps = this.props.steps;

		let labels = [this.props.steps[0], this.props.steps[nrSteps - 1]];
		let labelsHtml = labels.map((label, i) => {
			let classes = 'col';
			if (i === 0) {
				classes += ' text-left';
			} else if (i === labels.length - 1) {
				classes += ' text-right';
			} else {
				classes += ' text-center';
			}

			return (
				<div key={i} className={classes}>
					{label}
				</div>
			);
		});

		return (
			<div className="col-12">
				<div className="row">

					<link href="/css/simple-slider.css" rel="stylesheet" type="text/css"/>

					<div className="col-12 text-center">
						<div id="demo">{sliderSteps[this.props.value] || '0'}</div>
					</div>
					<div className="col-12">
						<div className="row">
							<div className="slidecontainer col-12">
								<input value={this.props.value} className="slider" min={min} max={max} type="range"
									   list="tickmarks" onChange={this.handleSliderChange} />
							</div>
						</div>
						<div className="row">
							{labelsHtml}
						</div>
					</div>
				</div>
			</div>
		);
	}

	handleSliderChange = (event) => {
		this.props.handle(parseInt(event.target.value, 10));
	};
}

export default withTranslation('result')(PartSlider);
